/**
 * Every operable rail runs in exactly one country, so the availability views can pin a flag next to the rail
 * name. Mirrors the corridor catalog in coloca-nest (`supported-rails.constant.ts`); a rail added there later
 * simply renders without a flag until it is mapped here.
 */
export interface RailCountry {
  iso2: string;
  labelKey: "country_ar" | "country_br" | "country_co" | "country_mx";
}

export const RAIL_COUNTRY: Record<string, RailCountry> = {
  SPEI: { iso2: "MX", labelKey: "country_mx" },
  PIX: { iso2: "BR", labelKey: "country_br" },
  CBU_CVU: { iso2: "AR", labelKey: "country_ar" },
  BREB: { iso2: "CO", labelKey: "country_co" },
  TRANSFIYA: { iso2: "CO", labelKey: "country_co" },
  PSE: { iso2: "CO", labelKey: "country_co" },
  NEQUI: { iso2: "CO", labelKey: "country_co" },
  BANCOLOMBIA_BUTTON: { iso2: "CO", labelKey: "country_co" },
  USDT: { iso2: "CO", labelKey: "country_co" },
};

/** What a USDT switch actually turns off, since the rail name alone does not say it is the OTC desk. */
export const RAIL_HINT: Record<string, "hint_usdt_payin" | "hint_usdt_payout"> = {
  "USDT:PAYIN": "hint_usdt_payin",
  "USDT:PAYOUT": "hint_usdt_payout",
};

/**
 * The currency each operable rail moves. Once every rail of a currency is off, members converting into it are
 * told its balance only leaves through support, so the maintenance dialog says when a flip completes that
 * set.
 */
export const RAIL_CURRENCY: Record<string, string> = {
  SPEI: "MXN",
  PIX: "BRL",
  CBU_CVU: "ARS",
  BREB: "COP",
  TRANSFIYA: "COP",
  PSE: "COP",
  NEQUI: "COP",
  BANCOLOMBIA_BUTTON: "COP",
  USDT: "USDT",
};
